type OneColumnContainerProps = {
  children: JSX.Element | JSX.Element[];
};

const OneColumnContainer = ({ children }: OneColumnContainerProps) => {
  return <div className="flex w-full mx-auto sm:max-w-7xl pt-2 flex-col">{children}</div>;
};

export default OneColumnContainer;
